const env = window.smart_button_sandbox ? 'sandbox' : 'production';
const payment_method = window.smart_button_preferred_paypal_payment_method;
const paypal_layout = window.smart_button_paypal_layout;

// let paypal_el = ['paypal-button-global', 'paypal-button'];
let payload = {
    env,
    locale: 'en_US',
    style: {
        layout: paypal_layout == 'yes_vertical' ? "vertical" : "horizontal",
        color: "gold",
        shape: "rect",
        size: "responsive",
        height: 48,
        label: location.pathname.includes('/products/')?"pay":"paypal",
        tagline: false
    },
}
let mixProperties = () => {
    let customFormProperties = { resume: true, files: {}, properties: {} }
    let customInput = document.querySelectorAll('.custom-form-properties input')
    let customForm =  document.querySelectorAll('.custom-form-properties form')
    if(!customForm.length){
        customForm = document.querySelectorAll('.addcart form')
    }
    if (customInput.length&&customForm.length) {
      let formData = new FormData(customForm[0]);
      customFormProperties.resume=customForm[0].reportValidity();
      for (let [key, val] of formData.entries()) {
          if( Object.prototype.toString.call(val)!=='[object File]'){
            if (customFormProperties.properties[key]) {
            customFormProperties.properties[key] = customFormProperties.properties[key] + ' , ' + val
            } else {
            customFormProperties.properties[key] = val
            }
          }
       }  
      customInput.forEach((item, index) => {
          let { name, files } = item;
          if (files && files.length) {
              customFormProperties.files[name] = files;
          } 
      })
      return customFormProperties;
  }else{
      return false;
  }
}
let parseFormDate = (keyName, files, properties, payload, payloadKey, formData) => {
    let cusFormData = formData ? formData : new FormData();
    for (const key in files) {
        for (const subKey in files[key]) {
            if (Object.hasOwnProperty.call(files[key], subKey)) {
                cusFormData.append(`${keyName}[${key}]`, files[key][subKey])
            }
        }
    }

    if (properties && Object.keys(properties).length) {
        for (const key in properties) {
            cusFormData.append(`${keyName}[${key}]`, properties[key])
        }
    }
    if (payload && Object.keys(payload).length) {
        for (const key in payload) {
            cusFormData.append(payloadKey ? `${payloadKey}[${key}]` : key, payload[key])
        }
    }
    return cusFormData;
}
function statis_event(name='',parameters={}) {
    axios.post('/api/statistics/events', {
      name,
      parameters: {
        cart_hash: window.getCookie('cart_hash'),
        url: window.location.href,
        ...parameters,
      },
    })
}
const hanlder = function () {
    document.querySelectorAll('.paypal-button-render').forEach((item, index) => {
        let only_render_id = item.id = 'paypal-button-render-' + index;
        let ppCreateOrder = async function () {
            let statis_data = { verify: true };
            try {
                let addproduct = item.getAttribute('addproduct');//data包括quantity,product_id，和变种id
                let add_cart_list = item.getAttribute('add_cart_list');//athena主题power加购是多个商品
                let group_checked_variants_info = item.getAttribute('group_checked_variants_info');//athena主题组合商品加购是多个商品
                let cartmes = null;
                let cart_item = [];
                cartmes = item.getAttribute('cartmes');
                if (cartmes) cartmes = JSON.parse(cartmes);
                if (add_cart_list) {
                    add_cart_list = JSON.parse(add_cart_list)
                } else {
                    add_cart_list = [];
                };
                if (group_checked_variants_info) {
                    group_checked_variants_info = JSON.parse(group_checked_variants_info)
                } else {
                    group_checked_variants_info = [];
                };
                if (cartmes && cartmes.cart) cart_item = Object.values(cartmes.cart);
                if (addproduct) {
                    let customFormProperties = mixProperties();
                    let payload = {}
                    let api = "/api/store/cart"
                    payload = JSON.parse(addproduct);
                    payload.quantity = payload.quantity || 1;
                    payload.addType ='product.add.paypal';
                    let filesOff = false;
                    if (customFormProperties) {
                        let { files, properties, resume } = customFormProperties;
                        if (!resume) { return }
                        filesOff = files && Object.keys(files).length
                        let propertiesOff = properties && Object.keys(properties).length
                        if (filesOff) {
                            payload = parseFormDate('properties', files, properties, payload);
                        } else if (propertiesOff) {
                            payload.properties = properties;
                        }
                    }
                    if ((add_cart_list && add_cart_list.length) || (group_checked_variants_info && group_checked_variants_info.length)) {
                        if(!add_cart_list || !add_cart_list.length) add_cart_list = [{...JSON.parse(addproduct)}];
                        api = "/api/store/batchCart"
                        payload = {
                            payload:"product.batch.paypal",
                            product: []
                        };
                        let formData = new FormData();
                        let filesOff = false;

                        if (customFormProperties) {
                            let { files, properties } = customFormProperties;
                            filesOff = files && Object.keys(files).length
                            let propertiesOff = properties && Object.keys(properties).length
                            if (filesOff) {
                                add_cart_list.forEach((item, index) => {
                                    console.log(item, 'item', index);
                                    formData = parseFormDate(`product[${index}][properties]`, files, properties, item, `product[${index}]`, formData);
                                })
                            } else if (propertiesOff) {
                                add_cart_list = add_cart_list.map(item => {
                                    return { ...item, properties: properties }
                                })
                            }
                        }
                        if (filesOff) {
                            let add_cart_list_length = add_cart_list.length;
                            group_checked_variants_info.forEach((item, index) => {
                                for (const key in item) {
                                    if (Object.hasOwnProperty.call(item, key)) {
                                        formData.append(`product[${add_cart_list_length + index}][${key}]`, item[key])
                                    }
                                }
                            });
                            payload = formData;
                        } else {
                            payload.product.push(...add_cart_list, ...group_checked_variants_info);
                        }
                    }
                    if (filesOff) {
                        payload.append('clear', 1)
                    } else {
                        payload.clear = true;
                    }
                    cartmes = await axios.post(api, payload);
                    cartmes = cartmes.data;
                    cart_item = Object.values(cartmes.cart);
                    if (window.fbq) {
                        window.send_fb_event('AddToCart', {
                            content_type: "product_group",
                            content_ids: cart_item.map(item => item?.product_id),
                            value: cartmes.cart_total,
                            num_items: cartmes.cart_contents_count,
                            content_name: cart_item.map(item => item?.product?.post_title),
                            currency: cartmes.currency || 'USD',
                            content_category:cart_item.map(item => item?.category_ids)
                        })
                    }
                    if (window.ttq){
                        window.send_ttp_event("AddToCart",{
                            content_id: cart_item.map(item => item?.product_id), 
                            quantity: cartmes.cart_contents_count,
                            value: cartmes.cart_total,
                            currency: window.checkoutcurrency||"USD"
                        })
                    }
                    
                    if (window._learnq) {
                        window._learnq.push(["track", "Added to Cart", {
                            "AddedItemProductName": cart_item.map(item => item?.product?.post_title),
                            "AddedItemProductID": cart_item.map(item => item?.product_id),
                            "AddedItemSKU": cart_item.map(item => item?.sku),
                            "AddedItemCategories": cart_item.map(item => item?.category_ids),
                            "AddedItemURL": cart_item.map(item => item?.public_url),
                            "AddedItemPrice": cartmes.cart_total,
                            "AddedItemQuantity": cartmes.cart_contents_count,
                        }]);
                    }
                }
                if (window._learnq && cartmes) {
                    const { hash, cart_total, cart } = cartmes
                    let items = []
                    let name = []
                    if (cart && cart.length) {
                        Object.values(cart).forEach(item => {
                            const obj = {
                                "ProductID": item.product.ID,
                                "SKU": item.product.sku,
                                "ProductName": item.product.post_title,
                                "Quantity": item.quantity,
                                "ItemPrice": item.product.price,
                                "RowTotal": item.line_total,
                                "ProductURL": item.product.public_url,
                                "ImageURL": item.product.feature_image && item.product.feature_image.url,
                                // "ProductCategories": ["Fiction", "Children"]
                            }
                            name.push(item.product.post_title)
                            items.push(obj)
                        })
                        window._learnq.push(["track", "Started Checkout", {
                            "$event_id": hash,
                            "$value": cart_total,
                            "ItemNames": name,
                            // "Categories": ["Fiction", "Children", "Classics"],
                            "Items": items
                        }]);
                    }
                }
                if (window.fbq && cartmes && cart_item.length) {
                    window.send_fb_event('InitiateCheckout', {
                        content_type: "product_group",
                        content_ids:cart_item.map(item => item?.product_id),
                        value: cartmes.cart_total,
                        num_items: cartmes.cart_contents_count,
                        content_name: cart_item.map(item => item?.product?.post_title),
                        currency: cartmes.currency || 'USD',
                    })
                }
                if (window.ttq && window.send_ttp_event) {
                    window.send_ttp_event('InitiateCheckout')
                }
                let pathname = window.location.pathname;
                let payload = {};
                if (pathname.includes('/checkouts') && pathname.split("/")[2]) {
                    payload['cart_hash'] = pathname.split("/")[2]
                }
                let res1 = await axios.post("/api/store/cart/start_checkout", payload);
                return payment_method == 'paypal_rest' ? res1.data.id : res1.data.token;
            } catch (error) {
                statis_data.verify = false;
                statis_data.error = error?.message || error?.response?.data?.message;
                let body = document.getElementsByTagName('body')[0];
                var message = error?.response?.data?.message;
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.errors
                ) {
                    message = Object.values(error.response.data.errors)[0][0];
                }
                var div = document.createElement('div');
                div.innerHTML = `
                <div role="alert" class="el-message el-message--error" style="top: 20px; z-index: 2002;"><i class="el-message__icon el-icon-error"></i><p class="el-message__content">${message}</p></div>`;
                body.append(div);
                setTimeout(() => {
                    body.removeChild(div);
                }, 4000);
            } finally {
                statis_event('checkout.paypal.authorize',statis_data)
            }
        }

        let ppOnAuthorize = function (data, actions) {
            statis_event('checkout.paypal.approve')
            document.cookie = `paypalApprove=success;path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT`;
            return actions.redirect();
        }

        let ppOnApprove = async function (data, actions) {
            let statis_data={ verify : true}
            try {
                let payload = {
                    'paypalOrderId': data.orderID
                };
                let res = await axios.post("/api/store/cart/approve_checkout", payload);
                document.cookie = `paypalApprove=success;path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT`;
                location.href = res.data.redirect
            } catch (error) {
                statis_data.verify=false;
                statis_data.error = error?.message || error?.response?.data?.message;
            } finally {
                statis_event('checkout.paypal.approve',statis_data)
            }

        }
        let ppOnError = function (error) {
            statis_event('checkout.paypal.authorize.failed',{error:error.message,})
        }
        if (payment_method == 'paypal_rest') {
            payload['createOrder'] = ppCreateOrder;
            payload['onApprove'] = ppOnApprove;
            payload['onError'] = ppOnError;
            paypal.Buttons(payload).render('#' + only_render_id);
        } else {
            payload['payment'] = ppCreateOrder;
            payload['onAuthorize'] = ppOnAuthorize;
            payload['onError'] = ppOnError;
            paypal.Button.render(payload, '#' + only_render_id)
        }
    })
}
function t() {
  if (typeof paypal != 'undefined' && document.querySelectorAll('.paypal-button-render').length) {
    hanlder()
  } else {
    setTimeout(t, 500)
  }
}
t()
